var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{attrs:{"inline":""}},[_c('b-form-select',{staticClass:"mb-1 mr-sm-1 mb-sm-0",attrs:{"size":"sm","options":_vm.options_select},model:{value:(_vm.transition),callback:function ($$v) {_vm.transition=$$v},expression:"transition"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }